// 表示切り替え
import commonClass from "./commonClass";

export default class switchDispAreaClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$prt = $('.js-switch');
    this._$trg = $('.js-switch-trg');
    this._tgt = '.js-switch-tgt';
    this._$radio = $('.js-switch-radio');
    this._radio_itm = '.c-frm_radio_itm';
    this._$tgt = $('.js-switch-tgt');
    this._$radio_multi = $('.js-switch-radio-multi');
    this._radio_multi = '.js-switch-radio-multi';
    this._switch_wrap = '.js-switch-wrap';
  }


  // 初期化用関数
  _init() {
    if(!(this._$prt.length)) return;
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    if(cls._$radio.length){
      // ラジオボタンの表示制御
      cls._rd(cls);
    } else {
      // ボタンの表示制御
      cls._btn(cls);
    }
  }

  _rd(cls) {
    cls._$trg.on('change', function () {
      var num = $(this).parents(cls._radio_itm).index();
      cls._$tgt.hide();
      cls._$tgt.eq(num).show();
    });

    //ページ内に複数の切り替えがある場合の処理
    cls._$radio_multi.on('change', function () {
      var $wrap = $(this).parents(cls._switch_wrap)
      var num = $wrap.find(cls._radio_multi).index(this);

      $wrap.find(cls._tgt).hide();
      $wrap.find(cls._tgt).eq(num).show();
    });
  }

  _btn(cls) {
    cls._$trg.on('click', function () {
      cls._$tgt.stop().slideDown();
    });
  }

}